(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // 'error' does not bubble, so we listen on the capture phase at the document level.
  // This is deduplicated by Shopify across every Hero section instance on the page.
  document.addEventListener(
    'error',
    (event) => {
      const image = event.target;
      if (!(image instanceof HTMLImageElement) || !image.classList.contains('hero__media--fallback-source')) return;

      const container = image.closest('.hero__media-wrapper, .hero__blurred-media-item');
      const fallback = container?.querySelector('.hero__media-fallback');
      if (!fallback) return;

      image.remove();
      fallback.hidden = false;
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
